import store from "@store/redux.store";

export const getLinkToMeeting = ({report}) => {
        const storeData = store.getState();
        if(report?.isOffline == 1){
            return '';
        }
        if(
            storeData?.settings?.isSeparateLinksForStudentsAndTeachers == '1' && 
            (storeData?.profile?.profile?.role === 'children' || storeData?.profile?.profile?.role === 'parent')
        ) {
            return report?.link_to_meeting_for_children;
        } 
        return report?.link_to_meeting;
}